import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import WorkspaceGrid from './WorkspaceGrid';

WorkspaceTabPanels.propTypes = {
  tabs: PropTypes.array,
  activeTabId: PropTypes.string,
  recordings: PropTypes.array,
  recordingMetadata: PropTypes.object,
  eventsMap: PropTypes.object,
  rules: PropTypes.array,
  activeRules: PropTypes.array,
  globalRules: PropTypes.array,
  globalActiveRuleIds: PropTypes.array,
  workspaceNotes: PropTypes.string,
  workspaceMarkers: PropTypes.array,
  otherTabsRules: PropTypes.array,
  onToggleGlobalRule: PropTypes.func,
  onCreateRule: PropTypes.func,
  onUpdateNotes: PropTypes.func,
  onUpdateMarkers: PropTypes.func,
  makeRemoveWidget: PropTypes.func.isRequired,
  makeUpdateWidget: PropTypes.func.isRequired,
  makeLayoutChange: PropTypes.func.isRequired,
  makeUpdateTabNotes: PropTypes.func.isRequired,
  makeUpdateTabMarkers: PropTypes.func.isRequired,
  makeToggleTabRule: PropTypes.func.isRequired,
};

/**
 * One grid per tab, all mounted, only the active one displayed.
 *
 * Mounting them all is deliberate: a widget holds live state — a chart's zoom,
 * a video's position, an in-flight fetch — and unmounting a hidden tab would
 * throw that away every time the user glanced at another tab. The per-tab
 * callbacks are built by the make* factories so a hidden grid still writes to
 * its own tab.
 */
export default function WorkspaceTabPanels({
  tabs = [],
  activeTabId,
  recordings,
  recordingMetadata,
  eventsMap,
  rules,
  activeRules,
  globalRules,
  globalActiveRuleIds,
  workspaceNotes,
  workspaceMarkers,
  otherTabsRules,
  onToggleGlobalRule,
  onCreateRule,
  onUpdateNotes,
  onUpdateMarkers,
  makeRemoveWidget,
  makeUpdateWidget,
  makeLayoutChange,
  makeUpdateTabNotes,
  makeUpdateTabMarkers,
  makeToggleTabRule,
}) {
  return (
    <Box sx={{ flex: 1, overflow: 'auto', pt: 5, pb: 12 }}>
      {tabs.map((tab) => (
        <Box key={tab.id} sx={{ display: tab.id === activeTabId ? 'block' : 'none' }}>
          <WorkspaceGrid
            widgets={tab.widgets || []}
            recordings={recordings}
            recordingMetadata={recordingMetadata}
            eventsMap={eventsMap}
            rules={rules}
            activeRules={activeRules}
            globalRules={globalRules}
            globalActiveRuleIds={globalActiveRuleIds}
            tabRules={tab.rules || []}
            tabActiveRuleIds={tab.activeRuleIds || []}
            workspaceNotes={workspaceNotes}
            workspaceMarkers={workspaceMarkers}
            tabNotes={tab.notes || ''}
            tabMarkers={tab.timelineMarkers || []}
            otherTabsRules={otherTabsRules}
            onToggleGlobalRule={onToggleGlobalRule}
            onCreateRule={onCreateRule}
            onUpdateNotes={onUpdateNotes}
            onUpdateMarkers={onUpdateMarkers}
            onRemoveWidget={makeRemoveWidget(tab.id)}
            onUpdateWidget={makeUpdateWidget(tab.id)}
            onLayoutChange={makeLayoutChange(tab.id)}
            onUpdateTabNotes={makeUpdateTabNotes(tab.id)}
            onUpdateTabMarkers={makeUpdateTabMarkers(tab.id)}
            onToggleTabRule={makeToggleTabRule(tab.id)}
          />
        </Box>
      ))}
    </Box>
  );
}
